import { type User } from "../api/client";
import { todayLocalDate } from "../lib/date";
import { DailyMealLogsPage } from "./DailyMealLogsPage";

export function TodayPage({ user }: { user: User }) {
  return <DailyMealLogsPage user={user} date={todayLocalDate()} mode="today" />;
}
